<template>
  <div>
    <el-form :inline="true" :model="queryFormModel" class="demo-form-inline" size="small">
      <el-form-item label="商户">
        <merchant-selector v-model="queryFormModel.merchantId" @change="merchantQueryChanged"></merchant-selector>
      </el-form-item>
      <el-form-item label="代理">
        <proxy-selector v-model="queryFormModel.proxyId" :merchant-id="queryFormModel.merchantId" :disabled="!queryFormModel.merchantId"></proxy-selector>
      </el-form-item>
      <el-form-item label="日期范围">
        <el-date-picker
          v-model="dateRange"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="标签">
        <el-input v-model="queryFormModel.tag" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="queryList">查 询</el-button>
      </el-form-item>
    </el-form>

    <el-pagination 
      style="margin-bottom: 5px; float: right;"
      background 
      layout="prev, pager, next" 
      :current-page.sync="page" 
      :page-size.sync="rows" 
      :total="tableTotal" 
      @current-change="currentPageChanged">
    </el-pagination>
    
    <el-table ref="taskTable" :data="tableData" :height="tableHeight" size="small" border style="width: 100%">
      <el-table-column prop="id" label="ID" width="200"></el-table-column>
      <el-table-column prop="merchantName" label="所属商户" width="300"></el-table-column>
      <el-table-column prop="proxyName" label="所属代理" width="300"></el-table-column>
      <el-table-column prop="tags" label="标签">
        <template slot-scope="scope">
          <el-tag v-for="tag in scope.row.tagList" :key="tag" style="margin-right: 2px;" size="small">{{tag}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" width="200"></el-table-column>
      <el-table-column fixed="right" label="操作" width="200">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="viewTaskScales(scope.row.id)">查看传秤状态</el-button>
          <el-button type="text" size="small" @click="viewTaskDetails(scope.row.id)">查看商品明细</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-drawer title="传称状态" :visible.sync="taskScalesDrawerVisible" direction="ltr" :size="1200">
      <el-table :data="taskScales" size="small" border style="width: 100%">
        <el-table-column prop="scaleName" label="称设备" width="250"></el-table-column>
        <el-table-column prop="executeState" label="执行状态" width="100">
          <template slot-scope="scope">
            <i v-if="scope.row.executeState == '0'" class="el-icon-info" style="color:#909399">未执行</i>
            <i v-else-if="scope.row.executeState == '1'" class="el-icon-warning" style="color:#E6A23C">执行中</i>
            <i v-else-if="scope.row.executeState == '2'" class="el-icon-success" style="color:#67C23A">执行成功</i>
            <i v-else-if="scope.row.executeState == '3'" class="el-icon-error" style="color:#F56C6C">执行失败</i>
          </template>
        </el-table-column>
        <el-table-column prop="executeResult" label="失败原因"></el-table-column>
        <el-table-column prop="autoRetryCount" label="自动重试次数" width="100"></el-table-column>
        <el-table-column prop="nextAutoRetryTime" label="下次自动重试时间" width="200"></el-table-column>
      </el-table>
    </el-drawer>

    <el-drawer title="任务商品" :visible.sync="taskDetailsDrawerVisible" direction="ltr" :size="1200">
      <el-table :data="taskDetails" size="small" border style="width: 100%">
        <el-table-column prop="itemCode" label="商品编码"></el-table-column>
        <el-table-column prop="itemBarcode" label="商品条码"></el-table-column>
        <el-table-column prop="itemName" label="商品名称"></el-table-column>
        <el-table-column prop="unitName" label="单位" width="80"></el-table-column>
        <el-table-column prop="pricingMode" label="计价方式" width="100">
          <template slot-scope="scope">
            {{pricingModeEnum[scope.row.pricingMode]}}
          </template>
        </el-table-column>
        <el-table-column prop="retailPrice" label="零售价" width="80"></el-table-column>
        <el-table-column prop="promotePrice" label="促销价" width="80"></el-table-column>
        <el-table-column prop="vipPrice" label="会员价" width="80"></el-table-column>
        <el-table-column prop="vipPrice1" label="会员价1" width="80"></el-table-column>
        <el-table-column prop="vipPrice2" label="会员价2" width="80"></el-table-column>
        <el-table-column prop="vipPrice3" label="会员价3" width="80"></el-table-column>
        <el-table-column prop="vipPrice4" label="会员价4" width="80"></el-table-column>
        <el-table-column prop="validDays" label="保质期天数" width="100"></el-table-column>
        <el-table-column prop="memo" label="备注"></el-table-column>
        <el-table-column prop="component" label="商品成分"></el-table-column>
      </el-table>
    </el-drawer>
  </div>
</template>

<script>
import httpClient from '../httpClient.js'
import MerchantSelector from './MerchantSelector.vue'
import ProxySelector from './ProxySelector.vue'
export default {
  name: "TaskList",
  components: {
    MerchantSelector,
    ProxySelector
  },
  data() {
    const today = new Date()
    today.setHours(0, 0, 0, 0)
    const fromDate = new Date(today.getTime() - 7 * 24 * 60 * 60 * 1000)
    const toDate = new Date(today.getTime() + 24 * 60 * 60 * 1000)
    return {
      page: 1,
      rows: 20,
      tableTotal: 0,
      tableData: [],
      tableHeight: 400,
      queryFormModel: { fromDate: fromDate, toDate: toDate },
      dateRange: [fromDate, toDate],
      taskScalesDrawerVisible: false,
      taskDetailsDrawerVisible: false,
      taskScales: [],
      taskDetails: [],
      pricingModeEnum: {
        '0': '普通商品',
        '1': '称重',
        '2': '计数',
      }
    }
  },
  methods: {
    queryList() {
      let data = {
        page: this.page,
        rows: this.rows,
        params: this.queryFormModel
      }
      httpClient.post("/api/task/query", data).then((response) => {
        this.tableTotal = response.data.data.total
        let list = response.data.data.list
        if (list) {
          list.forEach(row => {
            if (row.tags) {
              row.tagList = row.tags.split(',')
            }
          })
          this.tableData = list
        }
      })
    },
    currentPageChanged() {
      this.queryList()
    },
    calcTableHeight() {
      this.$nextTick(() => {
        const tableEl = this.$refs.taskTable && this.$refs.taskTable.$el
        const top = tableEl ? tableEl.getBoundingClientRect().top : 200
        this.tableHeight = Math.max(300, window.innerHeight - top - 30)
      })
    },
    merchantQueryChanged() {
      // 商户变化时重置代理选择
      this.queryFormModel.proxyId = null
    },
    viewTaskDetails(taskId) {
      this.taskDetailsDrawerVisible = true
      httpClient.get(`/api/task/${taskId}/details`).then((response) => {
        this.taskDetails = response.data.data
      })
    },
    viewTaskScales(taskId) {
      this.taskScalesDrawerVisible = true
      httpClient.get(`/api/task/${taskId}/scales`).then((response) => {
        this.taskScales = response.data.data
      })
    }
  },
  mounted() {
    this.queryList()
    this.calcTableHeight()
    window.addEventListener('resize', this.calcTableHeight)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.calcTableHeight)
  },
  watch: {
    dateRange(newDateRange) {
      if (newDateRange) {
        this.queryFormModel.fromDate = newDateRange[0]
        this.queryFormModel.toDate = newDateRange[1]
      }else  {
        this.queryFormModel.fromDate = null
        this.queryFormModel.toDate = null
      }
    }
  }
};
</script>